import { OneTrustCookiesListAdapter } from "./OneTrustCookiesList";

export { OneTrustCookiesListAdapter as OneTrustCookiesList };
